import React, { Component } from 'react';
import './modal.css';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import * as modalActions from './modalAction';
//import { layer } from '@fortawesome/fontawesome-svg-core';
import { Modal, Button } from 'react-bootstrap';
import ContractForm from '../Form/contractForm';
import RiskForm from '../Form/riskForm';
import ScheduleForm from '../Form/scheduleForm';

import ContactForm from '../Forms/contactForm';
import TDIForm from '../Forms/tdiForm';
import PAYSForm from '../Forms/paysForm';
import DOCForm from '../Forms/docForm';
import T0C0Form from '../Forms/GenericFormType/t0c0Form';
import NACE01Form from '../Forms/nace1Form';
import NACE02Form from '../Forms/nace2Form';
import NACE03Form from '../Forms/nace3Form';
import NACE04Form from '../Forms/nace4Form';


class ModalForm extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
        this.state = {
           
        };
        
    }
    
    updateData = (data) =>{
        this.props.onUpdateFormData(data);
    }
    onSaveData = (data) =>{
      this.props.onSaveData(data);
    }
   
    render() {
        var content = null;
        

        switch (this.props.node.type) {
          case "CTC":
            content = <ContactForm onSave={this.onSaveData.bind()} id={this.props.id}/>
            break;
          case "TDI":
            content = <TDIForm onSave={this.onSaveData.bind()} id={this.props.id}/>
            break;
          case "PAYS":
            content = <PAYSForm onSave={this.onSaveData.bind()} node={this.props.node} id={this.props.id} parentId={this.props.parentId}/>
            break;
          case "DOC":
            content = <DOCForm onSave={this.onSaveData.bind()} node={this.props.node} id={this.props.id}/>
            break;
          case "EN3":
            switch (this.props.node.subType) {
              // SECURITY FORMS
              case "DDA":
                content = <T0C0Form  onSave={this.onSaveData.bind()} node={this.props.node} id={this.props.id}/>
              break;
              case "TDG":
                content = <T0C0Form  onSave={this.onSaveData.bind()} node={this.props.node} id={this.props.id}/>
              break;
              // PARAMETERS FORMS
              case "NA1":
                content = <NACE01Form  onSave={this.onSaveData.bind()} node={this.props.node} id={this.props.id}/>
              break;
              case "NA2":
                content = <NACE02Form  onSave={this.onSaveData.bind()} node={this.props.node} parentId={this.props.parentId} id={this.props.id}/>
              break;
              case "NA3":
                content = <NACE03Form onSave={this.onSaveData.bind()} node={this.props.node} parentId={this.props.parentId} id={this.props.id}/>
              break;
              case "NA4":
                content = <NACE04Form onSave={this.onSaveData.bind()} node={this.props.node} parentId={this.props.parentId} id={this.props.id}/>
              break;
              default:
                content = <T0C0Form  onSave={this.onSaveData.bind()} node={this.props.node} id={this.props.id}/>
                break;
            }
            break;
          // case "RISK" :
          //   content = <RiskForm onUpdateData={this.updateData.bind()} id={this.props.ids.i} data={this.props.data}/>
          //   break;
          // case "SCHEDULE" :
          //   content = <ScheduleForm onUpdateData={this.updateData.bind()} ids={this.props.ids} data={this.props.data}/>
          //   break;
          default:
            break;
        }


        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.onHandleClose.bind(this,null)}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.data.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {content}
                </Modal.Body>
                </Modal>
          </div>
        );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(ModalForm);
  